import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { DesktopColumnLayoutComponent } from './desktop-column-layout/desktop-column-layout.component';
import { DesktopColumnComponent } from './desktop-column-layout/desktop-column/desktop-column.component';
import { DesktopDetailItemComponent } from './desktop-detail-item/desktop-detail-item.component';
import {
  DesktopDetailViewHeaderButtonComponent,
  // tslint:disable-next-line: max-line-length
} from './desktop-detail-view/desktop-detail-view-header/desktop-detail-view-header-button/desktop-detail-view-header-button.component';
import { DesktopDetailViewHeaderComponent } from './desktop-detail-view/desktop-detail-view-header/desktop-detail-view-header.component';
import { DesktopDetailViewComponent } from './desktop-detail-view/desktop-detail-view.component';
import { DesktopHeaderComponent } from './desktop-header/desktop-header.component';
import { DesktopListItemAdditionalInfoComponent } from './desktop-list-item/desktop-list-item-additional-info/desktop-list-item-additional-info.component';
import { DesktopListItemIconComponent } from './desktop-list-item/desktop-list-item-icon/desktop-list-item-icon.component';
import { DesktopListItemStatusComponent } from './desktop-list-item/desktop-list-item-status/desktop-list-item-status.component';
import { DesktopListItemComponent } from './desktop-list-item/desktop-list-item.component';
import { DesktopNewDetailItemComponent } from './desktop-new-detail-item/desktop-new-detail-item.component';
import { DesktopPageActionItemComponent } from './desktop-page/desktop-page-action-item/desktop-page-action-item.component';
import { DesktopPageListComponent } from './desktop-page/desktop-page-list/desktop-page-list.component';
import { DesktopPageComponent } from './desktop-page/desktop-page.component';

@NgModule({
  declarations: [
    DesktopPageComponent,
    DesktopPageListComponent,
    DesktopPageActionItemComponent,
    DesktopListItemComponent,
    DesktopListItemStatusComponent,
    DesktopListItemIconComponent,
    DesktopListItemAdditionalInfoComponent,
    DesktopDetailViewComponent,
    DesktopDetailViewHeaderComponent,
    DesktopDetailViewHeaderButtonComponent,
    DesktopColumnLayoutComponent,
    DesktopColumnComponent,
    DesktopDetailItemComponent,
    DesktopHeaderComponent,
    DesktopNewDetailItemComponent,
  ],
  imports: [CommonModule, IonicModule],
  exports: [
    DesktopPageComponent,
    DesktopPageListComponent,
    DesktopPageActionItemComponent,
    DesktopListItemComponent,
    DesktopListItemStatusComponent,
    DesktopListItemIconComponent,
    DesktopListItemAdditionalInfoComponent,
    DesktopDetailViewComponent,
    DesktopDetailViewHeaderComponent,
    DesktopDetailViewHeaderButtonComponent,
    DesktopColumnLayoutComponent,
    DesktopColumnComponent,
    DesktopDetailItemComponent,
    DesktopHeaderComponent,
    DesktopNewDetailItemComponent,
  ],
})
export class DesktopComponentsModule {}
